import axios from 'axios';
import { protectedResourcesScopes } from '../../../../auth/config';
import { acquireToken } from '../../../../auth/msal';

const scope = protectedResourcesScopes.core;
const apiUrl = `https://meris-backend.ashyflower-93837a9b.brazilsouth.azurecontainerapps.io`;
// const apiUrl = `http://localhost:3333`;

export interface ReadingProperty {
  name: string;
  units: string[];
}

export interface Property {
  name: string;
  type: 'string' | 'number' | 'enum';
  enumValue?: string[];
  required: boolean;
}

export interface CreateInstrumentCategoryRequest {
  name: string;
  readingProperties: ReadingProperty[];
  properties: Property[];
}

export interface InstrumentCategory extends CreateInstrumentCategoryRequest {
  id: string;
  _id?: string;
  createdAt?: string;
  updatedAt?: string;
}

export interface GetInstrumentCategoriesParams {
  limit?: number;
  offset?: number;
  search?: string;
}

export interface InstrumentCategoriesResponse {
  items: InstrumentCategory[];
  totalItems: number;
  uniqueValues: Record<string, any>;
}

export async function getInstrumentCategories(
  instance: any,
  params?: GetInstrumentCategoriesParams
): Promise<InstrumentCategoriesResponse> {
  try {
    const accessToken = await acquireToken(instance, scope);
    const queryParams = new URLSearchParams();

    if (params?.limit) queryParams.append('limit', params.limit.toString());
    if (params?.offset) queryParams.append('offset', params.offset.toString());
    if (params?.search) queryParams.append('search', params.search);

    const url = `${apiUrl}/instruments-category${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;

    const { data } = await axios.get(url, {
      headers: { Authorization: `Bearer ${accessToken}` },
    });

    // Se a API retorna um array simples, transformamos na estrutura esperada
    if (Array.isArray(data)) {
      return {
        items: data,
        totalItems: data.length,
        uniqueValues: {},
      };
    }

    return data;
  } catch (error) {
    throw error;
  }
}
//pipe

export async function getInstrumentCategoryById(instance: any, categoryId: string): Promise<InstrumentCategory> {
  try {
    const accessToken = await acquireToken(instance, scope);
    const { data } = await axios.get(`${apiUrl}/instruments-category/${categoryId}`, {
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    return data;
  } catch (error) {
    throw error;
  }
}

export async function createInstrumentCategory(instance: any, category: CreateInstrumentCategoryRequest): Promise<InstrumentCategory> {
  try {
    const accessToken = await acquireToken(instance, scope);
    const { data } = await axios.post(`${apiUrl}/instruments-category`, category, {
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    return data;
  } catch (error) {
    throw error;
  }
}

export async function updateInstrumentCategory(instance: any, categoryId: string, category: CreateInstrumentCategoryRequest): Promise<InstrumentCategory> {
  try {
    const accessToken = await acquireToken(instance, scope);
    const { data } = await axios.put(`${apiUrl}/instruments-category/${categoryId}`, category, {
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    return data;
  } catch (error) {
    throw error;
  }
}

export async function deleteInstrumentCategory(instance: any, categoryId: string): Promise<void> {
  try {
    const accessToken = await acquireToken(instance, scope);
    await axios.delete(`${apiUrl}/instruments-category/${categoryId}`, {
      headers: { Authorization: `Bearer ${accessToken}` },
    });
  } catch (error) {
    throw error;
  }
}